import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { ROUTES } from '../../common/constants';
import Donations from './Donations';

const DonationWrapper = () => {
  return (
    <Switch>
      <Route exact path={ROUTES?.DONATIONS} component={Donations} />
    </Switch>
  );
};

export default DonationWrapper;
